import { NavigationItem, RouteObject } from '../interfaces/inavigation-item';

export class NextPageOptionsModel {
    public sitename = 'change the sitename property on np-header';
    public menuStructure: Array<NavigationItem>;
    public eventResizeThreshold: number;
    public swipeDistanceThreshold: number;
    public mobileThreshold: number;
    public tabletThreshold: number;
    public slideRotationInterval: number;
    public alertDisableDuration: number;
    public navigationItems: Array<NavigationItem> = [];
    public navigationRoutes: Array<RouteObject> = [];

    constructor() {
        this.eventResizeThreshold = 100;
        this.swipeDistanceThreshold = 0.3
        this.mobileThreshold = 768;
        this.tabletThreshold = 1200;
        this.slideRotationInterval = 6000;
        this.alertDisableDuration = 86400000;
    }
}
